module.exports = __webpack_public_path__ + "img/chelsea.79baa935.jpeg";